import { TFunction } from "i18next";
import { ComponentValues, Cvss3P1 } from "./Cvss3P1";

interface CVSSValues {
    scope?: string;           // 0 = Unchanged, 1 = Changed
    attackVector?: string;    // 0 = Network, 1 = Adjacent, 2 = Local, 3 = Physical
    complexity?: string;      // 0 = Low, 1 = High
    privilegesRequired?: string; // 0 = None, 1 = Low, 2 = High
    userInteraction?: string; // 0 = None, 1 = Required
    confidentiality?: string; // 0 = None, 1 = Low, 2 = High
    integrity?: string;       // 0 = None, 1 = Low, 2 = High
    availability?: string;    // 0 = None, 1 = Low, 2 = High
  }
  
  export function calculateCVSS(values: CVSSValues) {
    const scope = values.scope ? parseInt(values.scope) : undefined;
    const attackVector = values.attackVector ? parseInt(values.attackVector) : undefined;
    const complexity = values.complexity ? parseInt(values.complexity) : undefined;
    const privilegesRequired = values.privilegesRequired ? parseInt(values.privilegesRequired) : undefined;
    const userInteraction = values.userInteraction ? parseInt(values.userInteraction) : undefined;
    const confidentiality = values.confidentiality ? parseInt(values.confidentiality) : undefined;
    const integrity = values.integrity ? parseInt(values.integrity) : undefined;
    const availability = values.availability ? parseInt(values.availability) : undefined;
    
    const C = Object.keys(ComponentValues.CONFIDENTIALITY_IMPACT_VALUES)[confidentiality !== undefined ? confidentiality + 1 : 0];
    const I = Object.keys(ComponentValues.INTEGRITY_IMPACT_VALUES)[integrity !== undefined ? integrity + 1 : 0];
    const AV = Object.keys(ComponentValues.AV_VALUES)[attackVector !== undefined ? attackVector + 1 : 0];
    const AC = Object.keys(ComponentValues.AC_VALUES)[complexity !== undefined ? complexity + 1 : 0];
    const UI = Object.keys(ComponentValues.UI_VALUES)[userInteraction !== undefined ? userInteraction + 1 : 0];    
    const A = Object.keys(ComponentValues.AVAILABILITY_IMPACT_VALUES)[availability !== undefined ? availability + 1 : 0];
    const S = Object.keys(ComponentValues.S_VALUES)[scope !== undefined ? scope + 1 : 0];
    const PR = Object.keys(ComponentValues.PR_VALUES)[privilegesRequired !== undefined ? privilegesRequired + 1 : 0];
    const cvss3 = new Cvss3P1(`CVSS:3.1/AV:${AV}/AC:${AC}/PR:${PR}/UI:${UI}/S:${S}/C:${C}/I:${I}/A:${A}`);
    return cvss3.calculateScores(true);
}

export const CvssService = {
    compute: (values: any): string => {
        const cvss = calculateCVSS(values);    
        return `${cvss.overall} - ${cvss.vector}`;
    },
    calculate: (t: TFunction, values: any) => {
        const baseScore = calculateCVSS(values).overall;
        // Rating and background class
        let rating = "";
        let bgClass = "bg-none";
        if (baseScore === 0) {
            rating = t("SimpleRating.None", "None");
            bgClass = "bg-none";
        }
        if (baseScore >= 0.1 && baseScore <= 3.9) {
            rating = t("SimpleRating.Low", "Low");
            bgClass = "bg-success";
        }
        if (baseScore >= 4.0 && baseScore <= 6.9) {
            rating = t("SimpleRating.Medium", "Medium");
            bgClass = "bg-light";
        }
        if (baseScore >= 7.0 && baseScore <= 8.9) {
            rating = t("SimpleRating.High", "High");
            bgClass = "bg-warning";
        }
        if (baseScore >= 9.0 && baseScore <= 10) {
            rating = t("SimpleRating.Critical", "Critical");
            bgClass = "bg-danger";
        }

        return { bgClass, baseScore, rating };
    }
}